import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

import FacebookStyleLoader from "../ChildComponents/Loading";
import { verifyToken } from "../Utils/authUtils";

const ProtectedRoute = () => {
  const { token } = useSelector((state) => state.user);
  const [isTokenValid, setIsTokenValid] = useState(null);

  useEffect(() => {
    const checkToken = async () => {
      const tokenIsValid = await verifyToken(token?.token);
      setIsTokenValid(tokenIsValid);
    };

    checkToken();
  }, []);

  if (isTokenValid === null) {
    return <FacebookStyleLoader />;
  }

  if (!token || !isTokenValid) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
